module.exports = __webpack_public_path__ + "img/icon-arrow-background-btn-down.24055176.svg";